module.exports = __webpack_public_path__ + "img/no-activity.88771b60.svg";